/**
 * NIHARA LUXURY FASHION — MOBILE GRID V3 & GLOBAL ENGINE SYSTEM
 * Full-featured Tab Navigation, Load More, Sorting, Quick Add & Wishlist System
 * Optimized implementation for performance and memory efficiency.
 */

(function() {
  'use strict';

  /* Money Formatter helper */
  function formatMoneyInr(cents) {
    if (cents === null || cents === undefined) return '';
    var val = Math.round(cents / 100);
    return 'Rs. ' + val.toLocaleString('en-IN');
  }

  /* Size Measurements mapping */
  var sizeMeasurements = {
    'XS': { chest: '32-33"', waist: '26-27"', hip: '34-35"' },
    'S':  { chest: '34-35"', waist: '28-29"', hip: '36-37"' },
    'M':  { chest: '36-37"', waist: '30-31"', hip: '38-39"' },
    'L':  { chest: '38-39"', waist: '32-33"', hip: '40-41"' },
    'XL': { chest: '40-41"', waist: '34-35"', hip: '42-43"' },
    'XXL':{ chest: '42-43"', waist: '36-37"', hip: '44-45"' }
  };

  /* Helper to query active grid inside section */
  function getActiveGrid(section) {
    return section.querySelector('.mobile-grid-v3.is-active, [data-collection-grid].is-active') ||
           section.querySelector('.mobile-grid-v3, [data-collection-grid]');
  }

  /* ==========================================================================
     1. V3 SECTION TAB NAVIGATION & INTERACTION MANAGER
     ========================================================================== */
  function MobileGridV3Manager(sectionEl) {
    this.section = sectionEl;
    this.drawer = null;
    this.inStockCheck = null;
    this.onSaleCheck = null;
    this.pricePills = null;
    this.viewAllBtn = null;
    this.init();
  }

  MobileGridV3Manager.prototype = {
    init: function() {
      var self = this;
      if (!this.section) return;

      // Cache drawer & filter elements once
      this.drawer = this.section.querySelector('.mobile-grid-v3-drawer');
      this.inStockCheck = this.section.querySelector('[data-v3-filter-instock]');
      this.onSaleCheck = this.section.querySelector('[data-v3-filter-onsale]');
      this.pricePills = this.section.querySelectorAll('.mobile-grid-v3-drawer__price-pill');
      this.viewAllBtn = this.section.querySelector('[data-v3-view-all-btn], .mobile-grid-v3__cta');

      // 1. Tab Navigation Click Listener
      var tabs = this.section.querySelectorAll('.mobile-grid-v3__filter-btn, [data-target-grid], [data-grid-v3-tab]');
      for (var i = 0; i < tabs.length; i++) {
        (function(tab) {
          tab.addEventListener('click', function(e) {
            e.preventDefault();
            var blockId = tab.getAttribute('data-target-grid') || tab.getAttribute('data-grid-v3-tab');
            var colUrl = tab.getAttribute('data-collection-url');
            self.switchTab(blockId, tab, colUrl);
          });
        })(tabs[i]);
      }

      // 2. Load More Button Listener
      var loadMoreBtns = this.section.querySelectorAll('[data-grid-v3-load-more]');
      for (var j = 0; j < loadMoreBtns.length; j++) {
        (function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            self.handleLoadMore(btn);
          });
        })(loadMoreBtns[j]);
      }

      // 3. Sort Select Listener
      var sortSelects = this.section.querySelectorAll('[data-v3-sort], [data-v3-sort-select]');
      for (var k = 0; k < sortSelects.length; k++) {
        (function(sel) {
          sel.addEventListener('change', function() {
            self.handleSort(sel.value);
          });
        })(sortSelects[k]);
      }

      // 4. Open Filter Drawer Listener
      var openFilterBtns = this.section.querySelectorAll('[data-v3-open-filter]');
      for (var m = 0; m < openFilterBtns.length; m++) {
        openFilterBtns[m].addEventListener('click', function(e) {
          e.preventDefault();
          self.openFilterDrawer();
        });
      }

      // 5. Close Filter Drawer Listener
      var closeFilterBtns = this.section.querySelectorAll('[data-v3-close-filter]');
      for (var n = 0; n < closeFilterBtns.length; n++) {
        closeFilterBtns[n].addEventListener('click', function(e) {
          e.preventDefault();
          self.closeFilterDrawer();
        });
      }

      // 6. Reset Filters Listener
      var resetBtn = this.section.querySelector('[data-v3-reset-filters]');
      if (resetBtn) {
        resetBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.resetFilters();
        });
      }

      // 7. Apply Filters Listener
      var applyBtn = this.section.querySelector('[data-v3-apply-filters]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.applyFilters();
          self.closeFilterDrawer();
        });
      }

      // 8. Price Pill Click Listener inside Drawer
      if (this.pricePills && this.pricePills.length) {
        for (var p = 0; p < this.pricePills.length; p++) {
          (function(pill) {
            pill.addEventListener('click', function() {
              for (var x = 0; x < self.pricePills.length; x++) {
                self.pricePills[x].classList.remove('is-active');
              }
              pill.classList.add('is-active');
            });
          })(this.pricePills[p]);
        }
      }
    },

    openFilterDrawer: function() {
      if (this.drawer) {
        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    },

    closeFilterDrawer: function() {
      if (this.drawer) {
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    },

    resetFilters: function() {
      var activeGrid = getActiveGrid(this.section);
      if (!activeGrid) return;

      if (this.inStockCheck) this.inStockCheck.checked = false;
      if (this.onSaleCheck) this.onSaleCheck.checked = false;

      if (this.pricePills && this.pricePills.length) {
        for (var i = 0; i < this.pricePills.length; i++) {
          if (i === 0) this.pricePills[i].classList.add('is-active');
          else this.pricePills[i].classList.remove('is-active');
        }
      }

      var cards = activeGrid.querySelectorAll('.mobile-card-v3');
      for (var j = 0; j < cards.length; j++) {
        cards[j].style.display = '';
        cards[j].removeAttribute('data-v3-filter-hidden');
      }
    },

    applyFilters: function() {
      var activeGrid = getActiveGrid(this.section);
      if (!activeGrid) return;

      var activePricePill = this.section.querySelector('.mobile-grid-v3-drawer__price-pill.is-active');
      var checkedSort = this.section.querySelector('input[name="v3_drawer_sort"]:checked');

      var minPrice = activePricePill ? parseFloat(activePricePill.getAttribute('data-v3-price-min') || '0') : 0;
      var maxPrice = activePricePill ? parseFloat(activePricePill.getAttribute('data-v3-price-max') || '9999999') : 9999999;
      var requireInStock = this.inStockCheck ? this.inStockCheck.checked : false;
      var requireOnSale = this.onSaleCheck ? this.onSaleCheck.checked : false;

      var cards = activeGrid.querySelectorAll('.mobile-card-v3');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var price = parseFloat(card.getAttribute('data-price') || '0');
        var available = card.getAttribute('data-available') === 'true';
        var hasSaleBadge = card.querySelector('.mobile-card-v3__badge--sale') !== null;

        var passPrice = price >= minPrice && price <= maxPrice;
        var passStock = !requireInStock || available;
        var passSale = !requireOnSale || hasSaleBadge;

        if (passPrice && passStock && passSale) {
          card.style.display = '';
          card.removeAttribute('data-v3-filter-hidden');
        } else {
          card.style.display = 'none';
          card.setAttribute('data-v3-filter-hidden', 'true');
        }
      }

      if (checkedSort && checkedSort.value) {
        this.handleSort(checkedSort.value, true);
      }
    },

    switchTab: function(blockId, activeTabEl, colUrl) {
      if (!blockId) return;

      var allTabs = this.section.querySelectorAll('.mobile-grid-v3__filter-btn, [data-target-grid], [data-grid-v3-tab]');
      for (var i = 0; i < allTabs.length; i++) {
        allTabs[i].classList.remove('is-active');
        allTabs[i].setAttribute('aria-selected', 'false');
      }
      if (activeTabEl) {
        activeTabEl.classList.add('is-active');
        activeTabEl.setAttribute('aria-selected', 'true');
      }

      var allGrids = this.section.querySelectorAll('.mobile-grid-v3, [data-collection-grid], [data-grid-v3-container]');
      var isCarouselSection = this.section.classList.contains('mobile-grid-v3-section--carousel');
      for (var j = 0; j < allGrids.length; j++) {
        var g = allGrids[j];
        var gridBlockId = g.getAttribute('data-collection-grid') || g.getAttribute('data-block-id');
        if (gridBlockId === blockId) {
          g.classList.remove('is-hidden');
          g.classList.add('is-active');
          var activeDisplay = (isCarouselSection || g.classList.contains('mobile-grid-v3--layout-carousel') || g.classList.contains('mobile-grid-v3--carousel-mobile')) ? 'flex' : 'grid';
          g.style.setProperty('display', activeDisplay, 'important');
        } else {
          g.classList.remove('is-active');
          g.classList.add('is-hidden');
          g.style.setProperty('display', 'none', 'important');
        }
      }

      if (this.viewAllBtn && colUrl) {
        this.viewAllBtn.setAttribute('href', colUrl);
      }
    },

    handleLoadMore: function(btn) {
      var activeGrid = getActiveGrid(this.section);
      if (!activeGrid) return;

      var isMobile = window.innerWidth <= 768;
      var hideSelector = isMobile ? '.v3-hide-mobile' : '.v3-hide-desktop';
      var allHidden = activeGrid.querySelectorAll('[data-v3-hidden="true"], .is-hidden-initial');
      var hiddenCards = [];
      for (var h = 0; h < allHidden.length; h++) {
        if (!allHidden[h].matches(hideSelector)) {
          hiddenCards.push(allHidden[h]);
        }
      }

      var batchSize = parseInt(btn.getAttribute('data-batch-size') || '6', 10);
      var count = 0;

      for (var i = 0; i < hiddenCards.length; i++) {
        if (count < batchSize) {
          var card = hiddenCards[i];
          card.removeAttribute('data-v3-hidden');
          card.classList.remove('is-hidden-initial');
          card.style.display = '';
          count++;
        }
      }

      var allRem = activeGrid.querySelectorAll('[data-v3-hidden="true"], .is-hidden-initial');
      var remCount = 0;
      for (var r = 0; r < allRem.length; r++) {
        if (!allRem[r].matches(hideSelector)) {
          remCount++;
        }
      }
      if (!remCount) {
        btn.style.display = 'none';
      }
    },

    handleSort: function(sortVal, isFiltered) {
      var activeGrid = getActiveGrid(this.section);
      if (!activeGrid) return;

      var promoSelectors = '.mobile-lookbook-card-v3, .mobile-video-card-v3, .mobile-editorial-banner-v3, .mobile-ig-card-v3, .mobile-story-card-v3, .mobile-countdown-card-v3, .mobile-split-card-v3, .v3-faq-block';
      var promoCards = activeGrid.querySelectorAll(promoSelectors);
      var isSortingOrFilteringActive = (sortVal && sortVal !== 'featured') || isFiltered;

      if (isSortingOrFilteringActive) {
        for (var p = 0; p < promoCards.length; p++) {
          promoCards[p].style.setProperty('display', 'none', 'important');
        }
      } else {
        for (var q = 0; q < promoCards.length; q++) {
          promoCards[q].style.display = '';
        }
      }

      var rawCards = activeGrid.querySelectorAll('.mobile-card-v3');
      if (!rawCards.length) return;

      // Pre-extract sort keys to prevent repeated DOM queries inside sort loop
      var cardList = [];
      for (var i = 0; i < rawCards.length; i++) {
        var el = rawCards[i];
        cardList.push({
          el: el,
          price: parseFloat(el.getAttribute('data-price') || '0'),
          title: (el.getAttribute('data-title') || '').toLowerCase().trim(),
          order: parseInt(el.getAttribute('data-original-order') || '0', 10)
        });
      }

      cardList.sort(function(a, b) {
        if (sortVal === 'price-ascending') return a.price - b.price;
        if (sortVal === 'price-descending') return b.price - a.price;
        if (sortVal === 'title-ascending') return a.title.localeCompare(b.title);
        if (sortVal === 'title-descending') return b.title.localeCompare(a.title);
        return a.order - b.order;
      });

      // Use DocumentFragment to batch DOM re-ordering in a single reflow
      var fragment = document.createDocumentFragment();
      for (var k = 0; k < cardList.length; k++) {
        fragment.appendChild(cardList[k].el);
      }
      activeGrid.appendChild(fragment);
    }
  };

  function initV3Sections(context) {
    var scope = context || document;
    var sections;
    if (scope.classList && (scope.classList.contains('mobile-product-grid-v3-section') || scope.hasAttribute('data-section-id'))) {
      sections = [scope];
    } else {
      sections = scope.querySelectorAll('.mobile-product-grid-v3-section, [data-section-id]');
    }

    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (!sec._v3Manager && (sec.classList.contains('mobile-product-grid-v3-section') || sec.querySelector('.mobile-grid-v3, [data-collection-grid]'))) {
        sec._v3Manager = new MobileGridV3Manager(sec);
      }
    }
  }

  /* ==========================================================================
     2. SINGLE CANONICAL QUICK ADD ENGINE
     ========================================================================== */
  window.NiharaQuickAddEngine = {
    isOpening: false,
    isAdding: false,
    activeModal: null,
    selectedVariant: null,
    elements: null,

    ensureModalDOM: function() {
      if (this.activeModal && document.body.contains(this.activeModal)) return;

      var existingModal = document.querySelector('.nihara-qa-modal');
      if (existingModal) {
        this.activeModal = existingModal;
        this.cacheModalElements();
        return;
      }

      var modalDiv = document.createElement('div');
      modalDiv.innerHTML = [
        '<div class="nihara-qa-modal" aria-hidden="true" role="dialog" aria-modal="true" style="display: none !important;">',
          '<div class="nihara-qa-backdrop" data-nihara-qa-close></div>',
          '<div class="nihara-qa-container">',
            '<button type="button" class="nihara-qa-close" data-nihara-qa-close aria-label="Close modal">&times;</button>',
            '<div class="nihara-qa-body">',
              '<div class="nihara-qa-loading" data-nihara-qa-loading>',
                '<div class="nihara-qa-spinner"></div>',
              '</div>',
              '<div class="nihara-qa-content" data-nihara-qa-content style="display: none;">',
                '<div class="nihara-qa-gallery-wrapper">',
                  '<button type="button" class="nihara-qa-gallery-arrow nihara-qa-gallery-arrow--prev" data-nihara-qa-gallery-prev aria-label="Previous image">&#10094;</button>',
                  '<div class="nihara-qa-gallery" data-nihara-qa-gallery></div>',
                  '<button type="button" class="nihara-qa-gallery-arrow nihara-qa-gallery-arrow--next" data-nihara-qa-gallery-next aria-label="Next image">&#10095;</button>',
                '</div>',
                '<div class="nihara-qa-header-row">',
                  '<h3 class="nihara-qa-title" data-nihara-qa-title>Product Title</h3>',
                  '<div class="nihara-qa-price-wrap">',
                    '<span class="nihara-qa-price" data-nihara-qa-price>(Rs. 0)</span>',
                    '<span class="nihara-qa-compare-price" data-nihara-qa-compare-price></span>',
                  '</div>',
                '</div>',
                '<p class="nihara-qa-subtitle" data-nihara-qa-subtitle>Nihara Silhouette</p>',
                '<div class="nihara-qa-measurements-bar">',
                  '<div class="nihara-qa-measurements-info" data-nihara-qa-measurements-info>',
                    'Chest <strong data-qa-meas-chest>36-37"</strong> High Waist <strong data-qa-meas-waist>30-31"</strong> Hip <strong data-qa-meas-hip>38-39"</strong>',
                  '</div>',
                  '<button type="button" class="nihara-qa-size-chart-btn" data-nihara-qa-open-sg>What\'s my size?</button>',
                '</div>',
                '<div class="nihara-qa-sizes-section">',
                  '<div class="nihara-qa-sizes-grid" data-nihara-qa-sizes-grid></div>',
                '</div>',
                '<button type="button" class="nihara-qa-add-btn" data-nihara-qa-submit-btn disabled>',
                  '<span>ADD TO CART</span>',
                '</button>',
                '<div class="nihara-qa-trust-row">',
                  '<span>&#214; Easy 7 Days Returns and Exchange</span>',
                '</div>',
              '</div>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');

      var node = modalDiv.firstElementChild;
      document.body.appendChild(node);
      this.activeModal = node;
      this.cacheModalElements();
    },

    cacheModalElements: function() {
      if (!this.activeModal) return;
      var m = this.activeModal;
      this.elements = {
        loading: m.querySelector('[data-nihara-qa-loading]'),
        content: m.querySelector('[data-nihara-qa-content]'),
        gallery: m.querySelector('[data-nihara-qa-gallery]'),
        title: m.querySelector('[data-nihara-qa-title]'),
        price: m.querySelector('[data-nihara-qa-price]'),
        comparePrice: m.querySelector('[data-nihara-qa-compare-price]'),
        sizesGrid: m.querySelector('[data-nihara-qa-sizes-grid]'),
        submitBtn: m.querySelector('[data-nihara-qa-submit-btn]'),
        submitBtnSpan: m.querySelector('[data-nihara-qa-submit-btn] span'),
        measChest: m.querySelector('[data-qa-meas-chest]'),
        measWaist: m.querySelector('[data-qa-meas-waist]'),
        measHip: m.querySelector('[data-qa-meas-hip]')
      };
    },

    open: function(handle) {
      if (this.isOpening || !handle) return;
      this.isOpening = true;
      var self = this;
      setTimeout(function() { self.isOpening = false; }, 400);

      this.ensureModalDOM();
      var modal = this.activeModal;
      if (!modal) return;

      var modals = document.querySelectorAll('.nihara-qa-modal');
      for (var i = 0; i < modals.length; i++) {
        modals[i].classList.remove('is-open');
        modals[i].style.setProperty('display', 'none', 'important');
      }

      modal.style.setProperty('display', 'flex', 'important');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      var els = this.elements;
      if (els && els.loading && els.content) {
        els.loading.style.display = 'flex';
        els.content.style.display = 'none';
      }

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          self.render(modal, product);
          if (els && els.loading && els.content) {
            els.loading.style.display = 'none';
            els.content.style.display = 'block';
          }
        })
        .catch(function(err) {
          console.error('Nihara Quick Add fetch error:', err);
          self.close();
        });
    },

    close: function() {
      if (this.activeModal) {
        this.activeModal.classList.remove('is-open');
        this.activeModal.style.setProperty('display', 'none', 'important');
      }
      var modals = document.querySelectorAll('.nihara-qa-modal');
      for (var i = 0; i < modals.length; i++) {
        modals[i].classList.remove('is-open');
        modals[i].style.setProperty('display', 'none', 'important');
      }
      document.body.style.overflow = '';
    },

    render: function(modal, product) {
      var self = this;
      var els = this.elements || {};
      var gallery = els.gallery;
      var titleEl = els.title;
      var priceEl = els.price;
      var comparePriceEl = els.comparePrice;
      var sizesGrid = els.sizesGrid;
      var submitBtn = els.submitBtn;

      if (gallery) {
        gallery.innerHTML = '';
        var images = (product.images || []).slice(0, 5);
        var fragment = document.createDocumentFragment();
        for (var i = 0; i < images.length; i++) {
          var imgUrl = images[i];
          if (imgUrl && imgUrl.indexOf('//') === 0) {
            imgUrl = window.location.protocol + imgUrl;
          }
          var item = document.createElement('div');
          item.className = 'nihara-qa-gallery-item';
          item.innerHTML = '<img src="' + imgUrl + '" alt="' + (product.title || '') + '" loading="lazy">';
          fragment.appendChild(item);
        }
        gallery.appendChild(fragment);
      }

      if (titleEl) titleEl.textContent = product.title;
      if (priceEl) priceEl.textContent = '(' + formatMoneyInr(product.price) + ')';
      if (comparePriceEl) {
        comparePriceEl.textContent = product.compare_at_price > product.price ? formatMoneyInr(product.compare_at_price) : '';
      }

      if (sizesGrid) {
        sizesGrid.innerHTML = '';
        var variants = product.variants || [];
        var firstAvailable = null;
        var gridFragment = document.createDocumentFragment();

        for (var j = 0; j < variants.length; j++) {
          (function(variant) {
            var btn = document.createElement('button');
            btn.type = 'button';
            var sizeLabel = (variant.option1 || variant.title).trim();
            btn.className = 'nihara-qa-size-pill' + (!variant.available ? ' is-disabled' : '');
            btn.textContent = sizeLabel;

            if (variant.available && !firstAvailable) firstAvailable = variant;

            btn.addEventListener('click', function() {
              if (!variant.available) return;
              self.selectVariant(modal, variant, btn, sizeLabel);
            });
            gridFragment.appendChild(btn);
          })(variants[j]);
        }
        sizesGrid.appendChild(gridFragment);

        if (firstAvailable) {
          var firstIndex = variants.indexOf(firstAvailable);
          var firstBtn = sizesGrid.children[firstIndex];
          var firstLabel = (firstAvailable.option1 || firstAvailable.title).trim();
          if (firstBtn) self.selectVariant(modal, firstAvailable, firstBtn, firstLabel);
        } else {
          if (submitBtn) {
            submitBtn.disabled = true;
            if (els.submitBtnSpan) els.submitBtnSpan.textContent = 'SOLD OUT';
          }
        }
      }

      if (submitBtn && !submitBtn._boundSubmit) {
        submitBtn._boundSubmit = true;
        submitBtn.addEventListener('click', function() {
          self.addToCart(modal);
        });
      }
    },

    selectVariant: function(modal, variant, btnEl, sizeLabel) {
      this.selectedVariant = variant;
      var els = this.elements || {};
      var sizesGrid = els.sizesGrid;
      if (sizesGrid) {
        var allPills = sizesGrid.querySelectorAll('.nihara-qa-size-pill');
        for (var i = 0; i < allPills.length; i++) {
          allPills[i].classList.remove('is-selected');
        }
      }
      if (btnEl) btnEl.classList.add('is-selected');

      var sizeKey = (sizeLabel || '').toUpperCase();
      if (sizeMeasurements[sizeKey]) {
        if (els.measChest) els.measChest.textContent = sizeMeasurements[sizeKey].chest;
        if (els.measWaist) els.measWaist.textContent = sizeMeasurements[sizeKey].waist;
        if (els.measHip) els.measHip.textContent = sizeMeasurements[sizeKey].hip;
      }

      var submitBtn = els.submitBtn;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        if (els.submitBtnSpan) els.submitBtnSpan.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
    },

    addToCart: function(modal) {
      var self = this;
      if (!this.selectedVariant || !this.selectedVariant.id || this.isAdding) return;
      this.isAdding = true;

      var els = this.elements || {};
      var submitBtn = els.submitBtn;
      var btnSpan = els.submitBtnSpan;
      if (submitBtn) submitBtn.disabled = true;
      if (btnSpan) btnSpan.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: this.selectedVariant.id, quantity: 1 }] })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (btnSpan) btnSpan.textContent = '✓ ADDED!';
        document.dispatchEvent(new CustomEvent('cart:after-add', { detail: item }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function() {
          self.isAdding = false;
          self.close();
        }, 600);
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        self.isAdding = false;
        if (submitBtn) submitBtn.disabled = false;
        if (btnSpan) btnSpan.textContent = 'ADD TO CART';
      });
    }
  };

  // Alias global controller
  window.NiharaQuickAddController = window.NiharaQuickAddEngine;

  /* ==========================================================================
     3. GLOBAL DOCUMENT DELEGATE FOR ALL CARDS, TABS & BUTTONS ACROSS STORE
     ========================================================================== */
  document.addEventListener('click', function(e) {
    var target = e.target;
    if (!target) return;

    // 0. Category Tab Filter Button Delegate
    var filterBtn = target.closest('.mobile-grid-v3__filter-btn, [data-target-grid], [data-grid-v3-tab]');
    if (filterBtn) {
      e.preventDefault();
      var section = filterBtn.closest('.mobile-product-grid-v3-section, [data-section-id], section');
      var blockId = filterBtn.getAttribute('data-target-grid') || filterBtn.getAttribute('data-grid-v3-tab');
      var colUrl = filterBtn.getAttribute('data-collection-url');

      if (section && blockId) {
        if (section._v3Manager) {
          section._v3Manager.switchTab(blockId, filterBtn, colUrl);
        } else {
          var allTabs = section.querySelectorAll('.mobile-grid-v3__filter-btn, [data-target-grid]');
          for (var i = 0; i < allTabs.length; i++) {
            allTabs[i].classList.remove('is-active');
          }
          filterBtn.classList.add('is-active');

          var allGrids = section.querySelectorAll('.mobile-grid-v3, [data-collection-grid]');
          var isCarouselSec = section.classList && section.classList.contains('mobile-grid-v3-section--carousel');
          for (var j = 0; j < allGrids.length; j++) {
            var g = allGrids[j];
            var gridId = g.getAttribute('data-collection-grid');
            if (gridId === blockId) {
              g.classList.remove('is-hidden');
              g.classList.add('is-active');
              var displayMode = (isCarouselSec || g.classList.contains('mobile-grid-v3--layout-carousel') || g.classList.contains('mobile-grid-v3--carousel-mobile')) ? 'flex' : 'grid';
              g.style.setProperty('display', displayMode, 'important');
            } else {
              g.classList.remove('is-active');
              g.classList.add('is-hidden');
              g.style.setProperty('display', 'none', 'important');
            }
          }
        }
      }
      return;
    }

    // 1. Wishlist Toggle Delegate
    var wishBtn = target.closest('.mobile-card-v3__wishlist, [data-wishlist-toggle], .wishlist-button, [data-action="add-to-wishlist"], .product-card__wishlist, .card__wishlist');
    if (wishBtn) {
      if (typeof window.NiharaWishlistToggle === 'function') {
        window.NiharaWishlistToggle(e, wishBtn);
      }
      return;
    }

    // 2. Quick Add Modal Delegate
    var addBtn = target.closest('[data-nihara-quick-add], .mobile-card-v3__quick-add-btn, [data-quick-add-trigger], .quick-add-btn');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = addBtn.closest('.mobile-card-v3, [data-product-handle], .product-card, .grid-item, .card-wrapper, .grid__item');
      var handle = (addBtn.getAttribute('data-product-handle') || (card ? card.getAttribute('data-product-handle') : '') || '').trim();
      if (!handle && card) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) {
          var href = link.getAttribute('href') || '';
          var parts = href.split('/products/');
          if (parts.length > 1) {
            handle = parts[1].split('?')[0].trim();
          }
        }
      }
      if (handle) {
        window.NiharaQuickAddEngine.open(handle);
      }
      return;
    }

    // 3. Close Quick Add Backdrop
    if (target.matches('.nihara-qa-backdrop') || target.closest('[data-nihara-qa-close]')) {
      e.preventDefault();
      e.stopPropagation();
      window.NiharaQuickAddEngine.close();
      return;
    }

    // 4. Quick Add Gallery Arrows
    var galPrev = target.closest('[data-nihara-qa-gallery-prev]');
    var galNext = target.closest('[data-nihara-qa-gallery-next]');
    if (galPrev || galNext) {
      e.preventDefault();
      e.stopPropagation();
      var modal = target.closest('.nihara-qa-modal');
      var gallery = modal ? modal.querySelector('[data-nihara-qa-gallery]') : null;
      if (gallery) {
        gallery.scrollBy({ left: galPrev ? -140 : 140, behavior: 'smooth' });
      }
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      window.NiharaQuickAddEngine.close();
    }
  });

  /* ==========================================================================
     4. TOUCH SWIPE LISTENER FOR CARD V3 IMAGES
     ========================================================================== */
  (function initCardTouchSwipe() {
    var startX = 0;
    var startY = 0;
    var activeWrapper = null;

    document.addEventListener('touchstart', function(e) {
      var wrapper = e.target.closest('.mobile-card-v3__image-wrapper, .mobile-card-v3');
      if (!wrapper) return;
      if (wrapper.closest('.mobile-grid-v3--layout-carousel, .mobile-grid-v3-section--carousel, .mobile-grid-v3--carousel-mobile')) return;
      
      if (e.target.closest('.mobile-card-v3__wishlist, [data-nihara-quick-add], .mobile-card-v3__quick-add-btn')) return;

      var touch = e.touches[0];
      if (touch) {
        startX = touch.clientX;
        startY = touch.clientY;
        activeWrapper = wrapper;
      }
    }, { passive: true });

    document.addEventListener('touchend', function(e) {
      if (!activeWrapper) return;
      var touch = e.changedTouches ? e.changedTouches[0] : null;
      if (!touch) { activeWrapper = null; return; }

      var deltaX = touch.clientX - startX;
      var deltaY = touch.clientY - startY;

      if (Math.abs(deltaX) > 25 && Math.abs(deltaX) > Math.abs(deltaY)) {
        var card = activeWrapper.closest('.mobile-card-v3') || activeWrapper;
        var secImg = card.querySelector('.mobile-card-v3__img--secondary');
        var dots = card.querySelectorAll('.mobile-card-v3__swipe-dot');

        if (secImg) {
          if (deltaX < 0) {
            // Swipe Left -> Second image slides in from the right
            card.classList.add('is-swiped');
            if (dots.length >= 2) {
              dots[0].classList.remove('is-active');
              dots[1].classList.add('is-active');
            }
          } else {
            // Swipe Right -> Return to primary image
            card.classList.remove('is-swiped');
            if (dots.length >= 2) {
              dots[1].classList.remove('is-active');
              dots[0].classList.add('is-active');
            }
          }
        }
      }

      activeWrapper = null;
    }, { passive: true });
  })();

  /* ==========================================================================
     5. FIRST-TIME SCROLL FADE-IN REVEAL FOR PRODUCT CARDS (MOBILE & DESKTOP)
     ========================================================================== */
  function initV3CardScrollReveal(context) {
    var scope = context || document;
    var cards = scope.querySelectorAll ? scope.querySelectorAll('.mobile-card-v3') : [];
    if (!cards.length) return;

    if (!window._v3CardRevealObserver && ('IntersectionObserver' in window)) {
      window._v3CardRevealObserver = new IntersectionObserver(function(entries, obs) {
        var batchIndex = 0;
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            var card = entry.target;
            obs.unobserve(card);
            var delay = Math.min(batchIndex * 65, 260);
            batchIndex++;
            card.style.setProperty('--v3-reveal-delay', delay + 'ms');
            card.classList.add('is-v3-revealed');
            (function(el, d) {
              setTimeout(function() {
                el.style.removeProperty('--v3-reveal-delay');
                el.style.willChange = 'auto';
              }, d + 750);
            })(card, delay);
          }
        }
      }, {
        root: null,
        rootMargin: '0px 0px -24px 0px',
        threshold: 0.08
      });
    }

    var observer = window._v3CardRevealObserver;
    for (var j = 0; j < cards.length; j++) {
      var c = cards[j];
      if (c._v3RevealObserved) continue;
      c._v3RevealObserved = true;
      if (observer) {
        c.classList.add('v3-card-reveal-ready');
        observer.observe(c);
      } else {
        c.classList.add('is-v3-revealed');
      }
    }
  }

  /* ==========================================================================
     6. BOOTSTRAP V3 SECTIONS & SHOPIFY THEME EDITOR LIFECYCLE
     ========================================================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initV3Sections();
      initV3CardScrollReveal();
    });
  } else {
    initV3Sections();
    initV3CardScrollReveal();
  }

  var lifecycleEvents = ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'];
  for (var idx = 0; idx < lifecycleEvents.length; idx++) {
    document.addEventListener(lifecycleEvents[idx], function(e) {
      var container = e.target || document;
      initV3Sections(container);
      initV3CardScrollReveal(container);
    });
  }

})();
